import gql from 'graphql-tag';

export const NAME =
  'compositions_CaseDetailOverviewPanel_createCaseDelayMutation';

// language=GraphQL
export default gql`
  mutation ${NAME} (
    $caseId: ID!
    $status: String!
    $reasonType: String!
    $customReason: String
  ) {
    createCaseDelay(
      input: {
        caseId: $caseId
        status: $status
        reasonType: $reasonType
        customReason: $customReason
      }
    ) {
      caseDelay {
        id
        startTime
        endTime
        status
        reasonType
        customReason
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseDetailOverviewPanel/withCaseDelays/createCaseDelayMutation.js